import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  // {
  //   path: "",
  //   title: "MENUITEMS.MAIN.TEXT",
  //   moduleName: "",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   submenu: [],
  // },

  // Admin Modules
  {
    path: "/admin/dashboard/main",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      // {
      //   path: "/admin/dashboard/main",
      //   title: "MENUITEMS.HOME.LIST.DASHBOARD1",
      //   moduleName: "dashboard",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   submenu: [],
      // },
      // {
      //   path: "/admin/dashboard/dashboard2",
      //   title: "MENUITEMS.HOME.LIST.DASHBOARD2",
      //   moduleName: "dashboard",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   submenu: [],
      // },
      // {
      //   path: "/admin/dashboard/doctor-dashboard",
      //   title: "MENUITEMS.HOME.LIST.DOCTOR-DASHBOARD",
      //   moduleName: "doctor-dashboard",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   submenu: [],
      // },
      // {
      //   path: "/admin/dashboard/patient-dashboard",
      //   title: "MENUITEMS.HOME.LIST.PATIENT-DASHBOARD",
      //   moduleName: "patient-dashboard",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: [""],
      //   submenu: [],
      // },
    ],
  },
  // {
  //   path: "home-front",
  //   title: "Home Page",
  //   moduleName: "front-site",
  //   iconType: "material-icons-two-tone",
  //   icon: "fact_check",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin", "Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "manage-users",
  //   title: "Manage Users",
  //   moduleName: "manage-users",
  //   iconType: "material-icons-two-tone",
  //   icon: "contacts",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin", "Doctor"],
  //   submenu: [],
  // },
  {
    path: "",
    title: "Manage Appointment",
    moduleName: "appointment",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      {
        path: "/admin/appointment/doctors-appointment",
        title: "Manage Doctors Appointment",
        moduleName: "appointment",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/appointment/hospitals-appointment",
        title: "Manage Hospitals Appointment",
        moduleName: "appointment",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
  {
    path: "./admin/medical-store/all-medical-store",
    title: "Manage Medical Store",
    moduleName: "medical-store",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  // {
  //   path: "",
  //   title: "Medical Store",
  //   moduleName: "medical-store",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/medical-store/all-medical-store",
  //       title: "All Medical store ",
  //       moduleName: "medical-store",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/medical-store/add-medical-store",
  //       title: "Add Medical Store",
  //       moduleName: "medical-store",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/medical-store/edit-medical-store",
  //       title: "Edit Medical Store",
  //       moduleName: "medical-store",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },


  // {
  //   path: "",
  //   title: "All Delivery Men",
  //   moduleName: "delivery-men",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/delivery-men/all-delivery-men",
  //       title: "All Delivery Men",
  //       moduleName: "delivery-men",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/appointment/bookAppointment",
  //       title: "MENUITEMS.APPOINTMENTS.LIST.BOOK-APPOINTMENT",
  //       moduleName: "appointment",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/appointment/edit-ppointment",
  //       title: "MENUITEMS.APPOINTMENTS.LIST.EDIT-APPOINTMENT",
  //       moduleName: "appointment",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  {
    path: "/admin/delivery-men/all-delivery-men",
    title: "Manage Delivery Man",
    moduleName: "delivery-men",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/manage-patient/patient-list",
    title: "Manage Patients",
    moduleName: "manage-patient",
    iconType: "material-icons-two-tone",
    icon: "face",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/manage-doctors/all-doctors",
    title: "Manage Doctors",
    moduleName: "manage-doctors",
    iconType: "material-icons-two-tone",
    icon: "face",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/manage-hospital/all-hospital",
    title: "Manage Hospitals",
    moduleName: "manage-hospital",
    iconType: "material-icons-two-tone",
    icon: "local_hospital",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },

  // Nabeela Comment Start
  {
    path: "",
    title: "Manage Orders",
    moduleName: "manage-orders",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      {
        path: "/admin/manage-orders/customer-orders",
        title: "Customer Orders",
        moduleName: "orders",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/manage-orders/medical-store-orders",
        title: "Medical Store Orders",
        moduleName: "orders",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/manage-orders/delivery-man-orders",
        title: "Delivery Man Orders",
        moduleName: "orders",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
  {
    path: "./admin/medicines/all-medicines-list",
    title: "Manage Medicines",
    moduleName: "medicines",
    iconType: "material-icons-two-tone",
    icon: "medication",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/manage-vaccine/all-vaccine",
    title: "Manage Vaccine",
    moduleName: "manage-vaccine",
    iconType: "material-icons-two-tone",
    icon: "vaccines",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/manage-disease/disease_list",
    title: "Manage Disease",
    moduleName: "manage-disease",
    iconType: "material-icons-two-tone",
    icon: "medication",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/manage-surgeries/all-surgery",
    title: "Manage Surgeries",
    moduleName: "manage-surgeris",
    iconType: "material-icons-two-tone",
    icon: "medication",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  // NAbeela Cmnt Start
  {
    path: "./admin/payment-methods/all-payment-methods",
    title: "Payment Methods",
    moduleName: "payment-methods",
    iconType: "material-icons-two-tone",
    icon: "payments",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  {
    path: "./admin/notifications/all-notifications",
    title: "Notifications",
    moduleName: "notifications",
    iconType: "material-icons-two-tone",
    icon: "notifications_active",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  // NABEELA cmnt End
  {
    path: "./admin/manage-registration-number/all-registration-number",
    title: "Manage Doctor Registration Number",
    moduleName: "manage-registration-number",
    iconType: "material-icons-two-tone",
    icon: "description",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  // Nabeela cmnt start
  {
    path: "./admin/platform-setting/setting",
    title: "Platform Settings",
    moduleName: "platform-setting",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: []
  },
  // {
  //   path: "",
  //   title: "Wallet",
  //   moduleName: "manage-wallet",
  //   iconType: "material-icons-two-tone",
  //   icon: "account_balance_wallet",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/manage-wallet/transaction-list",
  //       title: "Transactions",
  //       moduleName: "manage-wallet",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/manage-wallet/escrow-list",
  //       title: "Escrow",
  //       moduleName: "manage-wallet",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  {
    path: "./admin/send-email/email",
    title: "Email",
    moduleName: "send-email",
    iconType: "material-icons-two-tone",
    icon: "email",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },

  {
    path: "",
    title: "Withdrawals",
    moduleName: "withdrawal",
    iconType: "material-icons-two-tone",
    icon: "payments",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      {
        path: "/admin/withdrawal/list-of-patients",
        title: "Patients",
        moduleName: "withdrawal",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/withdrawal/list-of-doctors",
        title: "Doctors",
        moduleName: "withdrawal",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/withdrawal/list-of-hospitals",
        title: "Hospitals",
        moduleName: "withdrawal",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/withdrawal/list-of-medical-store",
        title: "Medical Store",
        moduleName: "withdrawal",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/withdrawal/list-of-delivery-man",
        title: "Delivery Man",
        moduleName: "withdrawal",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
  // NAbeela cmnt end
  {
    path: "",
    title: "Master",
    moduleName: "master",
    iconType: "material-icons-two-tone",
    icon: "people_alt",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      {
        path: "/admin/master/doctor-specialties",
        title: "Doctor Specialties",
        moduleName: "master",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/master/doctor-services",
        title: "Doctor Services",
        moduleName: "master",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/master/department-list",
        title: "Departments",
        moduleName: "master",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/master/medicine-category",
        title: "Medicine Category",
        moduleName: "master",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/master/medicine-subcategory",
        title: "Medicine Subcategory",
        moduleName: "master",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
  // NAbeela cmnt start
  {
    path: "",
    title: "Promo Codes",
    moduleName: "promo-codes",
    iconType: "material-icons-two-tone",
    icon: "people_alt",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      {
        path: "/admin/promo-codes/all-promo-codes",
        title: "All Promo codes",
        moduleName: "promo-codes",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/promo-codes/used-promo-codes",
        title: "Used Promo Codes",
        moduleName: "promo-codes",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Banners & Offers",
    moduleName: "banners-offers",
    iconType: "material-icons-two-tone",
    icon: "local_offer",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [
      {
        path: "/admin/banners-offers/all-banners",
        title: "All Banners",
        moduleName: "banners-offers",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
      {
        path: "/admin/banners-offers/all-offers",
        title: "All Offers",
        moduleName: "banners-offers",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [""],
        submenu: [],
      },
    ],
  },
  {
    path: "./admin/faq/faq",
    title: "Manage FAQ'S",
    moduleName: "faq",
    iconType: "material-icons-two-tone",
    icon: "quiz",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
  },
  // Nabeela Cmnt end


  // {
  //   path: "",
  //   title: "Orders",
  //   moduleName: "orders",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [],
  // },

  // {
  //   path: "",
  //   title: "MENUITEMS.PATIENTS.TEXT",
  //   moduleName: "patients",
  //   iconType: "material-icons-two-tone",
  //   icon: "face",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/patients/all-patients",
  //       title: "MENUITEMS.PATIENTS.LIST.ALL-PATIENT",
  //       moduleName: "patients",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/patients/add-patient",
  //       title: "MENUITEMS.PATIENTS.LIST.ADD-PATIENT",
  //       moduleName: "patients",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/patients/edit-patient",
  //       title: "MENUITEMS.PATIENTS.LIST.EDIT-PATIENT",
  //       moduleName: "patients",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/patients/patient-profile",
  //       title: "MENUITEMS.PATIENTS.LIST.PROFILE",
  //       moduleName: "patients",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.ROOMS.TEXT",
  //   moduleName: "room",
  //   iconType: "material-icons-two-tone",
  //   icon: "hotel",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/room/all-rooms",
  //       title: "MENUITEMS.ROOMS.LIST.ALLOTED-ROOMS",
  //       moduleName: "room",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/room/add-allotment",
  //       title: "MENUITEMS.ROOMS.LIST.NEW-ALLOTMENT",
  //       moduleName: "room",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/room/edit-allotment",
  //       title: "MENUITEMS.ROOMS.LIST.EDIT-ALLOTMENT",
  //       moduleName: "room",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "MENUITEMS.PAYMENTS.TEXT",
  //   moduleName: "payment",
  //   iconType: "material-icons-two-tone",
  //   icon: "monetization_on",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/admin/payment/all-payment",
  //       title: "MENUITEMS.PAYMENTS.LIST.ALL-PAYMENTS",
  //       moduleName: "payment",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/payment/add-payment",
  //       title: "MENUITEMS.PAYMENTS.LIST.ADD-PAYMENT",
  //       moduleName: "payment",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/admin/payment/invoice",
  //       title: "MENUITEMS.PAYMENTS.LIST.INVOICE",
  //       moduleName: "payment",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },

  // Doctor Start Here  ====================================================================================
  // {
  //   path: "/doctor/dashboard",
  //   title: "MENUITEMS.DOCTOR.DASHBOARD",
  //   moduleName: "dashboard",
  //   iconType: "material-icons-two-tone",
  //   icon: "home",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  {
    path: "/doctor/appointments",
    title: "MENUITEMS.DOCTOR.APPOINTMENTS",
    moduleName: "appointments",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  // {
  //   path: "/doctor/doctor-my-order",
  //   title: "My Order",
  //   moduleName: "My Orders",
  //   iconType: "material-icons-two-tone",
  //   icon: "shopping_cart",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  // // {
  //   path: "/doctor/patients",
  //   title: "MENUITEMS.DOCTOR.PATIENTS",
  //   moduleName: "patients",
  //   iconType: "material-icons-two-tone",
  //   icon: "face",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "/doctor/doctors",
  //   title: "MENUITEMS.DOCTOR.DOCTORS",
  //   moduleName: "doctors",
  //   iconType: "material-icons-two-tone",
  //   icon: "supervised_user_circle",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "/doctor/doctor-profile",
  //   title: "Doctor Profile",
  //   moduleName: "doctors",
  //   iconType: "material-icons-two-tone",
  //   icon: "supervised_user_circle",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  // Nabeela Cmnt start
  {
    path: "/doctor/wallet-withdrawal",
    title: "Wallet",
    moduleName: "doctors",
    iconType: "material-icons-two-tone",
    icon: "account_balance_wallet",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  // NAbeela Cmnt end
  {
    // path: "/apps/chat",
    // title: "MENUITEMS.DOCTOR.CHAT",
    // moduleName: "apps",
    path: "/doctor/reviews",
    title: "MENUITEMS.DOCTOR.REVIEWS",
    moduleName: "reviews",
    iconType: "material-icons-two-tone",
    icon: "reviews",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },

  // {
  //   path: "/doctor/manage-address/doctor-address",
  //   title: "Manage Address",
  //   moduleName: "manage-address",
  //   iconType: "material-icons-two-tone",
  //   icon: "home",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "/doctor/statistics",
  //   title: "Statistics",
  //   moduleName: "doctors",
  //   iconType: "material-icons-two-tone",
  //   icon: "trending_up",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Doctor"],
  //   submenu: [],
  // },
  // Nabeela Cmnt Start
  {
    path: "/doctor/faqs-doctor",
    title: "Faqs",
    moduleName: "extra-pages",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  {
    path: "/doctor/Term-and-Conditions",
    title: "Term & Conditions",
    moduleName: "hospital-notifictaion",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  {
    path: "/doctor/contact_us",
    title: "Contact Us",
    moduleName: "hospital-notifictaion",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Doctor"],
    submenu: [],
  },
  //Nabeela Cmnt End


  // Doctor END Here  ====================================================================================

  // Hospital Start Here===========================================================================
  {
    path: "/hospital/dashboard",
    title: "MENUITEMS.DOCTOR.DASHBOARD",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  // {
  //   path: "/hospital/create-patient",
  //   title: "Create patient",
  //   moduleName: "create-patient",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },

  {
    path: "/hospital/appointment",
    title: "MENUITEMS.DOCTOR.APPOINTMENTS",
    moduleName: "appointment",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  // {
  //   path: "/hospital/hospital_information",
  //   title: "Hospital Information",
  //   moduleName: "Hospital Information",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },
  // {
  //   path: "/hospital/profile",
  //   title: "Profile",
  //   moduleName: "profile",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },
  // {
  //   path: "/hospital/doctor-list",
  //   title: "Doctors",
  //   moduleName: "doctor-list",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },

  // {
  //   path: "/hospital/hospital_doctor",
  //   title: "My Doctors",
  //   moduleName: "my-doctors",
  //   iconType: "material-icons-two-tone",
  //   icon: "medication",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },
  {
    path: "/hospital/hospital-reviews",
    title: "Reviews",
    moduleName: "hospital-reviews",
    iconType: "material-icons-two-tone",
    icon: "reviews",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  {
    path: "/hospital/hospital-wallet",
    title: "Wallet",
    moduleName: "hospital-wallet",
    iconType: "material-icons-two-tone",
    icon: "account_balance_wallet",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  // {
  //   path: "/hospital/hospital-reviews",
  //   title: "Reviews",
  //   moduleName: "hospital-reviews",
  //   iconType: "material-icons-two-tone",
  //   icon: "reviews",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },

  // Nabeela Cmnt Start
  {
    path: "/extra-pages/faqs",
    title: "Faqs",
    moduleName: "extra-pages",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  {
    path: "/hospital/term_condition",
    title: "Term & Conditions",
    moduleName: "hospital-notifictaion",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  {
    path: "/hospital/contact_us",
    title: "Contact Us",
    moduleName: "hospital-notifictaion",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Hospital"],
    submenu: [],
  },
  // Nabeela Cmnt End

  // {
  //   path: "/hospital/hospital-appointment-detail",
  //   title: "AppointmentDetail",
  //   moduleName: "hospital-appointment-detail",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Hospital"],
  //   submenu: [],
  // },




  // Hospital END Here===========================================================================

  // Pharmacy  Module===============================================================================

  // {
  //   path: "/pharmacy/dashboard",
  //   title: "MENUITEMS.DOCTOR.DASHBOARD",
  //   moduleName: "dashboard",
  //   iconType: "material-icons-two-tone",
  //   icon: "home",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["medical_store"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/dashboard",
  //   title: "MENUITEMS.DOCTOR.DASHBOARD",
  //   moduleName: "dashboard",
  //   iconType: "material-icons-two-tone",
  //   icon: "home",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["drug_store"],
  //   submenu: [],
  // },
  {
    path: "/pharmacy/my-orders",
    title: "My Orders",
    moduleName: "my-orders",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["medical_store"],
    submenu: [],
  },
  {
    path: "/pharmacy/my-orders",
    title: "My Orders",
    moduleName: "my-orders",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["drug_store"],
    submenu: [],
  },
  // Nabeela cmnt start
  {
    path: "/pharmacy/pharmacy-transaction",
    title: "Wallet",
    moduleName: "pharmacy-wallet",
    iconType: "material-icons-two-tone",
    icon: "account_balance_wallet",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["medical_store"],
    submenu: [],
  },
  {
    path: "/pharmacy/pharmacy-wallet",
    title: "Wallet",
    moduleName: "pharmacy-wallet",
    iconType: "material-icons-two-tone",
    icon: "account_balance_wallet",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["drug_store"],
    submenu: [],
  },
  {
    path: "/pharmacy/medicine/medicine-list",
    title: "My Items",
    moduleName: "medicine",
    iconType: "material-icons-two-tone",
    icon: "local_hospital",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["medical_store"],
    submenu: [],
  },
  {
    path: "/pharmacy/medicine/medicine-list",
    title: "My Items",
    moduleName: "medicine",
    iconType: "material-icons-two-tone",
    icon: "local_hospital",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["drug_store"],
    submenu: [],
  },
  // Nabeela cmnt end
  // {
  //   path: "",
  //   title: "Medicine",
  //   moduleName: "medicine",
  //   iconType: "material-icons-two-tone",
  //   icon: "email",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   // submenu: [
  //   //   {
  //   //     path: "/pharmacy/medicine/medicine-list",
  //   //     title: "Medicine List",
  //   //     moduleName: "medicine",
  //   //     iconType: "",
  //   //     icon: "",
  //   //     class: "",
  //   //     groupTitle: false,
  //   //     badge: "",
  //   //     badgeClass: "",
  //   //     role: [""],
  //   //     submenu: [],
  //   //   },
  //   //   {
  //   //     path: "/pharmacy/medicine/add-medicine",
  //   //     title: "Add Medicine",
  //   //     moduleName: "medicine",
  //   //     iconType: "",
  //   //     icon: "",
  //   //     class: "",
  //   //     groupTitle: false,
  //   //     badge: "",
  //   //     badgeClass: "",
  //   //     role: [""],
  //   //     submenu: [],
  //   //   },
  //   //   {
  //   //     path: "/pharmacy/medicine/edit-medicine",
  //   //     title: "Edit Medicine",
  //   //     moduleName: "medicine",
  //   //     iconType: "",
  //   //     icon: "",
  //   //     class: "ml-menu",
  //   //     groupTitle: false,
  //   //     badge: "",
  //   //     badgeClass: "",
  //   //     role: [""],
  //   //     submenu: [],
  //   //   },
  //   // ],
  // },



  // {
  //   path: "/pharmacy/delivery-men-list",
  //   title: "Delivery Men List",
  //   moduleName: "delivery-men-list",
  //   iconType: "material-icons-two-tone",
  //   icon: "email",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/prescription-list",
  //   title: "Prescription List",
  //   moduleName: "prescription-list",
  //   iconType: "material-icons-two-tone",
  //   icon: "email",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/view-prescription",
  //   title: "View Prescription",
  //   moduleName: "view-prescription",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // Nabeela cmnt start
  {
    path: "/pharmacy/Term-and-Conditions",
    title: "Term & Conditions",
    moduleName: "Terms & Conditions",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["medical_store"],
    submenu: [],
  },
  {
    path: "/pharmacy/Term-and-Conditions",
    title: "T&C",
    moduleName: "Terms & Conditions",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["drug_store"],
    submenu: [],
  },

  {
    path: "/pharmacy/contact-us",
    title: "Contact Us",
    moduleName: "contact us",
    iconType: "material-icons-two-tone",
    icon: "email",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["medical_store"],
    submenu: [],
  },
  {
    path: "/pharmacy/contact-us",
    title: "Contact Us",
    moduleName: "contact us",
    iconType: "material-icons-two-tone",
    icon: "email",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["drug_store"],
    submenu: [],
  },

  {
    path: "/pharmacy/faqs-pharmacy",
    title: "FAQs",
    moduleName: "FAQs",
    iconType: "material-icons-two-tone",
    icon: "feedback",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["medical_store"],
    submenu: [],
  },
  {
    path: "/extra-pages/faqs",
    title: "FAQs",
    moduleName: "FAQs",
    iconType: "material-icons-two-tone",
    icon: "feedback",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["drug_store"],
    submenu: [],
  },
  // Nabeela cmnt end
  // {
  //   path: "/pharmacy/order-details",
  //   title: "Order Details",
  //   moduleName: "order-details",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/assign-delivery-man",
  //   title: "Assign Delivery Men",
  //   moduleName: "assign-deliveryman",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/order-complete",
  //   title: "Order Complete",
  //   moduleName: "assign-deliveryman",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/accepted-order",
  //   title: "Order",
  //   moduleName: "accepted-order",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/support",
  //   title: "Chat",
  //   moduleName: "support",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  // {
  //   path: "/pharmacy/pharmacy-review",
  //   title: "Review",
  //   moduleName: "pharmacy-review",
  //   iconType: "material-icons-two-tone",
  //   icon: "reviews",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },



  // {
  //   path: "/pharmacy/analytics",
  //   title: "Analytics Report",
  //   moduleName: "analytics",
  //   iconType: "material-icons-two-tone",
  //   icon: "assignment",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["pharmacy"],
  //   submenu: [],
  // },
  {
    path: "/drugstore/dashboard",
    title: "MENUITEMS.DOCTOR.DASHBOARD",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Drugstore"],
    submenu: [],
  },
  {
    path: "/drugstore/wallet",
    title: "Wallet",
    moduleName: "drugstore-wallet",
    iconType: "material-icons-two-tone",
    icon: "account_balance_wallet",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Drugstore"],
    submenu: [],
  },
  {
    path: "/drugstore/my_items/item_list",
    title: "My Items",
    moduleName: "medicine",
    iconType: "material-icons-two-tone",
    icon: "local_hospital",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Drugstore"],
    submenu: [],
  },
  {
    path: "/drugstore/My_Orders",
    title: "My Orders",
    moduleName: "my order",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Drugstore"],
    submenu: [],
  },
  {
    path: "/drugstore/contact_us",
    title: "Contact Us",
    moduleName: "Contact Us",
    iconType: "material-icons-two-tone",
    icon: "mail",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Drugstore"],
    submenu: [],
  },
  {
    path: "/extra-pages/faqs",
    title: "Faqs",
    moduleName: "extra-pages",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Drugstore"],
    submenu: [],
  },


  // Patient Modules================================================================================
  {
    path: "/patient/dashboard",
    title: "MENUITEMS.PATIENT.DASHBOARD",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  {
    path: "/patient/patient-doctor",
    title: "Doctors",
    moduleName: "patient-doctor",
    iconType: "material-icons-two-tone",
    icon: "person_add",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  // {
  //   path: "/patient/hospitals",
  //   title: "Hospitals",
  //   moduleName: "patient-doctor",
  //   iconType: "material-icons-two-tone",
  //   icon: "local_hospital",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Patient"],
  //   submenu: [],
  // },
  {
    path: "/patient/appointments/upcoming",
    title: "MENUITEMS.PATIENT.APPOINTMENTS.TEXT",
    moduleName: "appointments",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [

    ],
  },

  // {
  //   path: "/patient/EMR",
  //   title: "EMR",
  //   moduleName: "EMR",
  //   iconType: "material-icons-two-tone",
  //   icon: "info",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Patient"],
  //   submenu: [],
  // },
  // {
  //   path: "/patient/shop",
  //   title: "Shop",
  //   moduleName: "hospitals",
  //   iconType: "material-icons-two-tone",
  //   icon: "shopping_cart",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Patient"],
  //   submenu: [],
  // },


  {
    path: "/patient/medical-store-list",
    title: "Medical Store",
    moduleName: "medical-store-list",
    iconType: "material-icons-two-tone",
    icon: "medical_services",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  // Nabeela Cmnt Start
  {
    path: "/patient/wallet",
    title: "Wallet",
    moduleName: "wallet",
    iconType: "material-icons-two-tone",
    icon: "account_balance_wallet",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  {
    path: "/patient/saved-addresses",
    title: "My Address",
    moduleName: "Manage Address",
    iconType: "material-icons-two-tone",
    icon: "location_on",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  // Nabeela Cmnt End


  {
    path: "/order/order-list",
    title: "My Orders",
    moduleName: "Order List",
    iconType: "material-icons-two-tone",
    icon: "shopping_cart",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },

  // Nabeela Cmnt Start
  {
    path: "/patient/contact-us",
    title: "Contact Us",
    moduleName: "contact us",
    iconType: "material-icons-two-tone",
    icon: "message",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  {
    path: "/patient/Term-and-Conditions",
    title: "T&C",
    moduleName: "Terms & conditions",
    iconType: "material-icons-two-tone",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  {
    path: "/extra-pages/faqs",
    title: "FAQs",
    moduleName: "FAQs",
    iconType: "material-icons-two-tone",
    icon: "quiz",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Patient"],
    submenu: [],
  },
  // Nabeela Cmnt End

  // {
  // path: "/patient/records",
  // title: "MENUITEMS.PATIENT.MEDICAL-RECORD",
  // moduleName: "records",
  // iconType: "material-icons-two-tone",
  // icon: "restore_page",
  //class: "",
  // groupTitle: false,
  // badge: "",
  //badgeClass: "",
  // role: ["Patient"],
  //submenu: [],
  //},
  // {
  // path: "/patient/billing",
  //title: "MENUITEMS.PATIENT.BILLING",
  //moduleName: "records",
  //iconType: "material-icons-two-tone",
  //icon: "receipt",
  //class: "",
  //groupTitle: false,
  //badge: "",
  //badgeClass: "",
  //role: ["Patient"],
  //submenu: [],
  //},
  //{
  //path: "/apps/chat",
  // title: "MENUITEMS.PATIENT.CHAT",
  // moduleName: "apps",
  //iconType: "material-icons-two-tone",
  //icon: "chat",
  //class: "",
  //groupTitle: false,
  //badge: "",
  //badgeClass: "",
  //role: ["Patient"],
  //submenu: [],
  //},
  // {
  //   path: "/patient/settings",
  //   title: "MENUITEMS.PATIENT.SETTINGS",
  //   moduleName: "settings",
  //   iconType: "material-icons-two-tone",
  //   icon: "settings",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Patient"],
  //   submenu: [],
  // },

  // =====================================================================================================

  // Common Modules

  // {
  //   path: "",
  //   title: "-- Apps",
  //   moduleName: "",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin", "Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "calendar",
  //   title: "Calendar",
  //   moduleName: "calendar",
  //   iconType: "material-icons-two-tone",
  //   icon: "event_note",
  //   class: "",
  //   groupTitle: false,
  //   badge: "New",
  //   badgeClass: "badge bg-blue sidebar-badge float-right",
  //   role: ["Admin", "Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "task",
  //   title: "Task",
  //   moduleName: "task",
  //   iconType: "material-icons-two-tone",
  //   icon: "fact_check",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin", "Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "contacts",
  //   title: "Contacts",
  //   moduleName: "contacts",
  //   iconType: "material-icons-two-tone",
  //   icon: "contacts",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin", "Doctor"],
  //   submenu: [],
  // },
  // {
  //   path: "",
  //   title: "Email",
  //   moduleName: "email",
  //   iconType: "material-icons-two-tone",
  //   icon: "email",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin", "Doctor"],
  //   submenu: [
  //     {
  //       path: "/email/inbox",
  //       title: "Inbox",
  //       moduleName: "email",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/email/compose",
  //       title: "Compose",
  //       moduleName: "email",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/email/read-mail",
  //       title: "Read Email",
  //       moduleName: "email",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "More Apps",
  //   moduleName: "apps",
  //   iconType: "material-icons-two-tone",
  //   icon: "stars",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "4",
  //   badgeClass: "badge bg-orange sidebar-badge float-right",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/apps/chat",
  //       title: "Chat",
  //       moduleName: "apps",
  //       iconType: "material-icons-two-tone",
  //       icon: "chat",
  //       class: "",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/apps/dragdrop",
  //       title: "Drag & Drop",
  //       moduleName: "apps",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/apps/contact-grid",
  //       title: "Contact Grid",
  //       moduleName: "apps",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/apps/support",
  //       title: "Support",
  //       moduleName: "apps",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Widgets",
  //   moduleName: "widget",
  //   iconType: "material-icons-two-tone",
  //   icon: "widgets",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/widget/chart-widget",
  //       title: "Chart Widget",
  //       moduleName: "widget",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/widget/data-widget",
  //       title: "Data Widget",
  //       moduleName: "widget",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "-- Components",
  //   moduleName: "",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [],
  // },
  // {
  //   path: "",
  //   title: "User Interface (UI)",
  //   moduleName: "ui",
  //   iconType: "material-icons-two-tone",
  //   icon: "dvr",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/ui/alerts",
  //       title: "Alerts",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/badges",
  //       title: "Badges",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/chips",
  //       title: "Chips",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/modal",
  //       title: "Modal",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/buttons",
  //       title: "Buttons",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/expansion-panel",
  //       title: "Expansion Panel",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/bottom-sheet",
  //       title: "Bottom Sheet",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/dialogs",
  //       title: "Dialogs",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/cards",
  //       title: "Cards",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/labels",
  //       title: "Labels",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/list-group",
  //       title: "List Group",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/media-object",
  //       title: "Media Object",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/snackbar",
  //       title: "Snackbar",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/preloaders",
  //       title: "Preloaders",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/progressbars",
  //       title: "Progress Bars",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/tabs",
  //       title: "Tabs",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/typography",
  //       title: "Typography",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/ui/helper-classes",
  //       title: "Helper Classes",
  //       moduleName: "ui",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Forms",
  //   moduleName: "forms",
  //   iconType: "material-icons-two-tone",
  //   icon: "subtitles",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/forms/form-controls",
  //       title: "Form Controls",
  //       moduleName: "forms",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/advance-controls",
  //       title: "Advanced Controls",
  //       moduleName: "forms",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/form-example",
  //       title: "Form Examples",
  //       moduleName: "forms",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/form-validation",
  //       title: "Form Validation",
  //       moduleName: "forms",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/wizard",
  //       title: "Form Wizard",
  //       moduleName: "forms",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/forms/editors",
  //       title: "Editors",
  //       moduleName: "forms",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Tables",
  //   moduleName: "tables",
  //   iconType: "material-icons-two-tone",
  //   icon: "view_list",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/tables/basic-tables",
  //       title: "Basic Tables",
  //       moduleName: "tables",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/tables/material-tables",
  //       title: "Material Tables",
  //       moduleName: "tables",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/tables/ngx-datatable",
  //       title: "ngx-datatable",
  //       moduleName: "tables",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Medias",
  //   moduleName: "media",
  //   iconType: "material-icons-two-tone",
  //   icon: "image_search",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/media/gallery",
  //       moduleName: "media",
  //       title: "Image Gallery",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Charts",
  //   moduleName: "charts",
  //   iconType: "material-icons-two-tone",
  //   icon: "insert_chart",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "7",
  //   badgeClass: "badge bg-green sidebar-badge float-right",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/charts/echart",
  //       title: "Echart",
  //       moduleName: "charts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/apex",
  //       title: "Apex",
  //       moduleName: "charts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/chartjs",
  //       title: "ChartJS",
  //       moduleName: "charts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/ngx-charts",
  //       title: "Ngx-Charts",
  //       moduleName: "charts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/charts/gauge",
  //       title: "Gauge",
  //       moduleName: "charts",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Timeline",
  //   moduleName: "timeline",
  //   iconType: "material-icons-two-tone",
  //   icon: "amp_stories",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/timeline/timeline1",
  //       title: "Timeline 1",
  //       moduleName: "timeline",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/timeline/timeline2",
  //       title: "Timeline 2",
  //       moduleName: "timeline",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Icons",
  //   moduleName: "icons",
  //   iconType: "material-icons-two-tone",
  //   icon: "eco",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/icons/material",
  //       title: "Material Icons",
  //       moduleName: "icons",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/icons/font-awesome",
  //       title: "Font Awesome",
  //       moduleName: "icons",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Authentication",
  //   moduleName: "authentication",
  //   iconType: "material-icons-two-tone",
  //   icon: "supervised_user_circle",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/authentication/signin",
  //       title: "Sign In",
  //       moduleName: "authentication",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/signup",
  //       title: "Sign Up",
  //       moduleName: "authentication",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/forgot-password",
  //       title: "Forgot Password",
  //       moduleName: "authentication",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/locked",
  //       title: "Locked",
  //       moduleName: "authentication",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/page404",
  //       title: "404 - Not Found",
  //       moduleName: "authentication",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/authentication/page500",
  //       title: "500 - Server Error",
  //       moduleName: "authentication",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Extra Pages",
  //   moduleName: "extra-pages",
  //   iconType: "material-icons-two-tone",
  //   icon: "description",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/extra-pages/profile",
  //       title: "Profile",
  //       moduleName: "extra-pages",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/pricing",
  //       title: "Pricing",
  //       moduleName: "extra-pages",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/invoice",
  //       title: "Invoice",
  //       moduleName: "extra-pages",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/faqs",
  //       title: "Faqs",
  //       moduleName: "extra-pages",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/extra-pages/blank",
  //       title: "Blank Page",
  //       moduleName: "extra-pages",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Maps",
  //   moduleName: "maps",
  //   iconType: "material-icons-two-tone",
  //   icon: "map",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/maps/google",
  //       title: "Google Map",
  //       moduleName: "maps",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Multi level Menu",
  //   moduleName: "multilevel",
  //   iconType: "material-icons-two-tone",
  //   icon: "slideshow",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [
  //     {
  //       path: "/multilevel/first1",
  //       title: "First",
  //       moduleName: "multilevel",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //     {
  //       path: "/",
  //       title: "Second",
  //       moduleName: "secondlevel",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-sub-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [
  //         {
  //           path: "/multilevel/secondlevel/second1",
  //           title: "Second 1",
  //           moduleName: "secondlevel",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-sub-sub-menu",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //         {
  //           path: "/multilevel/secondlevel/second2",
  //           title: "Second 2",
  //           moduleName: "secondlevel",
  //           iconType: "",
  //           icon: "",
  //           class: "ml-sub-sub-menu",
  //           groupTitle: false,
  //           badge: "",
  //           badgeClass: "",
  //           role: [""],
  //           submenu: [],
  //         },
  //       ],
  //     },
  //     {
  //       path: "/multilevel/first3",
  //       title: "Third",
  //       moduleName: "multilevel",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       role: [""],
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "/authentication/signin",
  //   title: "Logout",
  //   moduleName: "logout",
  //   iconType: "material-icons-two-tone",
  //   icon: "power_settings_new",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   submenu: [],
  // },
];
